// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"78573515","453":"ab3a33bf"}[chunkId] + ".chunk.js";
};